import { Lightbox } from '@design-system';

import { MAX_LIGHTBOX_IMAGE_WIDTH } from '../../../constants';
import { imageLoader } from '../../../helpers/images';
import { TrackMultiMediaClick } from '../../../utils/analytics';
import { Image } from '../../Image';

type Props = {
  blok: GiftCardBanner;
  exampleGiftCard: StoryblokImage;
  analytics?: Analytics;
};

const GiftCardBanner: React.FC<Props> = ({
  analytics,
  blok,
  exampleGiftCard,
}) => {
  return (
    <div className="relative overflow-hidden rounded-sm">
      <Image
        alt={blok.image.alt}
        eagerLoading
        focus={blok.image.focus}
        size={{
          sm: { ratio: '3/2', span: 12 },
          md: { ratio: '3/2', span: 12 },
          lg: { ratio: '3/1', span: 12 },
        }}
        src={blok.image.filename}
      />
      <div className="absolute right-0 top-0 flex h-full w-full flex-col items-center justify-center text-white">
        <p className="text-center text-lg text-white">{blok.title}</p>
        <Lightbox
          items={[
            {
              copyright: exampleGiftCard.copyright,
              key: 0,
              media: {
                alt: exampleGiftCard.alt,
                src: imageLoader({
                  src: exampleGiftCard.filename,
                  width: MAX_LIGHTBOX_IMAGE_WIDTH,
                }),
                type: 'IMAGE',
              },
            },
          ]}
        >
          {(lightbox) => (
            <div
              onClick={() => {
                analytics &&
                  TrackMultiMediaClick({
                    page: analytics.page,
                    pageTitle: analytics.pageTitle,
                    context: analytics.context,
                    type: 'giftcard',
                    title: 'Sample Gift Card',
                  });
              }}
            >
              <p className="pt-3 text-center">
                <button
                  className="hyperlink"
                  onClick={() => {
                    lightbox.openOnSlide(0);
                  }}
                  type="button"
                >
                  {blok.subtitle}
                </button>
              </p>
            </div>
          )}
        </Lightbox>
      </div>
    </div>
  );
};

export default GiftCardBanner;
